import React from 'react';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import PropTypes from 'prop-types';
import TemplateOptionsMenu from 'Components/UI/TemplateOptionsMenu';
import { pickFunction } from 'Helpers/Affordances';

const MessageTemplateOptionsMenu = (
  TemplateOptionsMenuProps,
) => {
  const { userResource, isAgent } = useUserContext();

  const TemplateOptionsMenuComponent = pickFunction(userResource, {
    [fr.relationships.default.name]: () => {
      return null;
    },
    [fr.relationships.activityFeed.name]: () => {
      return (
        <TemplateOptionsMenu
          useLegacyButton
          {...TemplateOptionsMenuProps}
        />
      );
    },
  });

  return isAgent && TemplateOptionsMenuComponent;
};

MessageTemplateOptionsMenu.defaultProps = {
  TemplateOptionsMenu: {},
};

MessageTemplateOptionsMenu.propTypes = {
  TemplateOptionsMenuProps: PropTypes.object,
};

export default MessageTemplateOptionsMenu;
